"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _EyeOutlined = _interopRequireDefault(require("@foxui/ui-icons-svg/lib/asn/EyeOutlined"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _EyeOutlined.default
  }));
};

/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDEyYTQgNCAwIDExOCAwIDQgNCAwIDAxLTggMHptNC0yYTIgMiAwIDEwMCA0IDIgMiAwIDAwMC00eiIgZmlsbC1ydWxlPSJldmVub2RkIiAvPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuMDggNi43QTEwLjc5IDEwLjc5IDAgMDExMiA0YzIuODYgMCA1LjIgMS4yNiA2LjkyIDIuN2ExNy43MyAxNy43MyAwIDAxMy41IDQuMDVsLjAzLjA0Yy4xMi4xOS4yNy40My4zNS43Ni4wNi4yOC4wNi42MiAwIC45LS4wOC4zMy0uMjMuNTctLjM1Ljc2bC0uMDIuMDRjLS42Ljk0LTEuNzggMi42LTMuNSA0LjA0QTEwLjc5IDEwLjc5IDAgMDExMiAyMGMtMi44NiAwLTUuMi0xLjI2LTYuOTItMi43YTE3LjczIDE3LjczIDAgMDEtMy41My00LjFjLS4xMi0uMTgtLjI3LS40Mi0uMzUtLjc1YTIuMTYgMi4xNiAwIDAxMC0uOWMuMDgtLjMzLjIzLS41Ny4zNS0uNzZsLjAyLS4wNGMuNi0uOTQgMS43OC0yLjYgMy41LTQuMDR6bTEuMjggMS41NEExNS43MyAxNS43MyAwIDAwMy4xNiAxMmExLjUgMS41IDAgMDAuMS4xOGMuNTQuODQgMS42IDIuMzIgMy4xIDMuNThBOC44IDguOCAwIDAwMTIgMThhOC44IDguOCAwIDAwNS42NC0yLjI0IDE1LjczIDE1LjczIDAgMDAzLjItMy43NiAxLjc3IDEuNzcgMCAwMC0uMS0uMTggMTUuNzMgMTUuNzMgMCAwMC0zLjEtMy41OEE4LjggOC44IDAgMDAxMiA2YTguOCA4LjggMCAwMC01LjY0IDIuMjR6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/React.forwardRef(EyeOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'EyeOutlined';
}
var _default = exports.default = RefIcon;